<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" v-if="signedIn">
            <a class="navbar-brand" href="#">{{title_text}}</a>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">

<!--                <ul class="navbar-nav mr-auto" v-if="account_data_ready">-->
                  <ul class="navbar-nav mr-auto">

<!--                 Top menu for BW Noah, CN-->
                    <template v-if="menu_banner_type === 100">

                      <li class="nav-item active">
                        <router-link to="/" class="nav-link" >Home</router-link>
                      </li>

                      <li>
                        <router-link to="/lfb_graph" class="nav-link" >LFB</router-link>
                      </li>

                      <li>
                        <router-link to="/last_orders" class="nav-link" >All Acc</router-link>
                      </li>

                      <li>
                        <router-link to="/14pack_orders" class="nav-link" >14 Pack</router-link>
                      </li>

                      <li>
                        <router-link to="/noahs_orders" class="nav-link" >Noah's</router-link>
                      </li>

                      <li>
                        <router-link to="/hard8th_orders" class="nav-link" >Hard 8th</router-link>
                      </li>

                      <li>
                        <router-link to="/hidden_list" class="nav-link" >Hidden</router-link>
                      </li>

                      <li>
                        <router-link to="/samples_only" class="nav-link" >Samples</router-link>
                      </li>

                      <li>
                        <router-link to="/noahs_orders_only" class="nav-link" >Noah's Only</router-link>
                      </li>

                      <li>
                        <router-link to="/compare" class="nav-link" >Compare</router-link>
                      </li>

                      <li>
                        <router-link to="/sleep" class="nav-link" >Sleep</router-link>
                      </li>

                      <li>
                        <router-link to="/vape" class="nav-link" >Vapes</router-link>
                      </li>

                      <li>
                        <router-link to="/account_receivables" class="nav-link" >AR</router-link>
                      </li>

                      <li>
                        <router-link to="/account_receivables_log" class="nav-link" >AR-Log</router-link>
                      </li>

                      <li>
                        <router-link to="/customer_multiple" class="nav-link" >Eaze</router-link>
                      </li>

                      <li>
                        <router-link to="/one_plant" class="nav-link" >One Plant</router-link>
                      </li>

                      <li>
                        <router-link to="/ewc_sgi" class="nav-link" >EwcSgi</router-link>
                      </li>


<!--                      <li>-->
<!--                        <router-link to="/vegas" class="nav-link" >Vegas</router-link>-->
<!--                      </li>-->
                      <li>
                        <router-link to="/vegas_new" class="nav-link" >Vegas</router-link>
                      </li>



                      <li>
                        <router-link to="/web_accounts" class="nav-link" >Web Acc</router-link>
                      </li>

                      <li>
                        <router-link to="/ca_map" class="nav-link" >Map</router-link>
                      </li>

                      <li>
                        <router-link to="/roads" class="nav-link" >Roads</router-link>
                      </li>

                      <li>
                        <router-link to="/calls" class="nav-link" >Calls</router-link>
                      </li>

                      <li>
                        <router-link to="/froot_wheel_detail" class="nav-link" >FWD</router-link>
                      </li>

                      <li>
                        <router-link to="/froot_wheel_winners" class="nav-link" >FWW</router-link>
                      </li>

                      <li>
                        <router-link to="/froot_wheel_triggers" class="nav-link" >FWT</router-link>
                      </li>
                      
                      
<!--           never used, I turned it off where, is in Rani etc. to save space on menu top -->
<!--                      <li>-->
<!--                        <router-link to="/prospects" class="nav-link" >Prospects</router-link>-->
<!--                      </li>-->



<!--                      <li>-->
<!--                        <router-link to="/pistil_history" class="nav-link" >pistil_history</router-link>-->
<!--                      </li>-->




                    </template>


                    <!-- Top menu for BW Noah, CN VIA NEW TAB order detail from map-->
                    <template v-if="menu_banner_type === 120">
                      <li class="nav-link">
                        NEW TAB
                      </li>
                    </template>


<!--                    Top Menu for Lana-->
                    <template v-if="menu_banner_type === 200">
                      <li class="nav-item active">
                        <router-link to="/" class="nav-link" >Home</router-link>
                      </li>
                      <li>
                        <router-link to="/account_receivables" class="nav-link" >Account Receivables</router-link>
                      </li>
                    </template>

<!--                    Michelle todo: michelle main-->
                    <template v-if="menu_banner_type === 300">
                      <li class="nav-item active">
                        <router-link to="/" class="nav-link" >Home</router-link>
                      </li>
                      <li>
                        <router-link to="/last_orders" class="nav-link" >All Accounts</router-link>
                      </li>
                      <li>
                        <router-link to="/prospects" class="nav-link" >Prospects</router-link>
                      </li>

                      <li>
                        <router-link to="/commission" class="nav-link" >Commission</router-link>
                      </li>

                      <li>
                        <router-link to="/account_agents" class="nav-link" >LFB Accounts</router-link>
                      </li>



                    </template>

<!--                    <button @click="signOut" class="nav-link">Sign Out TEST</button>-->

                  </ul>



            </div>
        </nav>

      <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" v-if="!signedIn">
        <a class="navbar-brand" href="#">{{title_text}}</a>
        <button @click="signOut" class="nav-link">Sign In</button>
      </nav>



    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {signOut} from '../utils/auth'

    export default {
        data() {
          return {
            title_text: process.env.VUE_APP_ADMIN_ENV_TEXT
          }
        },
        computed: {
            ...mapGetters({
              signedIn:'auth/signedIn',
              menu_banner_type: 'admin/menu_banner_type', // sent with report if direct new sign in opening
            }),
        },
        methods: {
            signOut() {
                signOut();
                this.$router.push("/signin");
            },
        }
    }
</script>
